import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import $ from 'jquery';
import { ProginstalasiPage } from '../proginstalasi/proginstalasi';

/**
 * Generated class for the ResumeinstalasiPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-resumeinstalasi',
  templateUrl: 'resumeinstalasi.html',
})
export class ResumeinstalasiPage {

  nowo: any;
  datawo: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams
    ) {
      this.nowo = this.navParams.get('nowo');
      this.getData();
      this.datawo = JSON.parse(localStorage.getItem('detailwo'))[0];
  }

  ionViewDidLoad() {
    this.getData();
    console.log(this.datawo);
  }

  getData(){
    var nowo = this.nowo;
    $.ajax({
      url: "http://35.240.151.223:43209/newapimobile/get-data-detail-wo/"+nowo,
      type: "get",
      dataType: "json",
      success: function (result) {
        var pesan = result.pesan;
        var data = result.data;
        localStorage.setItem('detailwo', JSON.stringify(data));
      }
    });
  }

  cekStatus1(value) {
    let color = new String;
    if (value == '0') {//0 = UNREAD    ABU-ABU
      color = "onnotyet";
    } else if (value == '1') {//2 = PROGRESS	BIRU
      color = "onproccess";
    } else if (value == '2') {//   3 = CLOSE		  MERAH
      color = "onclose";
    }
    return color;
  }

  cekStatus2(value) {
    let txt = new String;
    if (value == '0') { //0 = blm proses    ABU-ABU
      txt = "NOT YET";
    } else if (value == '1') { //2 = PROGRESS	BIRU
      txt = "ON PROCESS";
    } else if (value == '2') { //   3 = CLOSE		MERAH
      txt = "CLOSED";
    }
    return txt;
  }

  progressInstalasi(datawo){
    this.navCtrl.push(ProginstalasiPage, {"datawo": datawo });
  }

}



// WEBPACK FOOTER //
// ./src/pages/resumeinstalasi/resumeinstalasi.ts